import dynamic from 'next/dynamic';
import React, { FC } from 'react';

import type { Props } from './ComponentIntercom.Lazy';

const LazyComponentIntercom = dynamic(() => import('./ComponentIntercom.Lazy'), {
    ssr: false,
});

const ComponentIntercom: FC<Props> = (props) => <LazyComponentIntercom {...props} />;

export { ComponentIntercom };
